import { request, requestAdmin, Res } from './common';
import { GetAuthTokenResponse } from 'application-types';

export interface RawBuilding {
  id: string;
  name: string;
  account_id?: string;
}

export type RawListBuildingData = {
  count: number;
  results: RawBuilding[];
  next?: string | null;
  previous?: string | null;
};

export interface Building {
  id: string;
  name: string;
  accountId?: string;
}

export type ListBuildingData = {
  count: number;
  results: Building[];
  next?: string | null;
  previous?: string | null;
};

export type ListBuildingDataOk = ListBuildingData & {
  isError: false;
};

export type ListBuildingDataError = {
  detail?: string;
  message?: string;
  error?: string;
  isError: true;
};

export type BEPrismCredentials = {
  email: string;
  password: string;
  channelId: string;
  integrationId: string;
  token: string | null;
};

export async function getBuildingList(
  bePrismCredentials: BEPrismCredentials,
  building_scope?: string
): Promise<Res<RawListBuildingData>> {

  return requestAdmin({
    ...bePrismCredentials,
    method: 'get',
    path: `/buildings`,
    params: {
      ...(building_scope ? { building_scope } : {}),
      ...(bePrismCredentials.integrationId ? { integration_id: bePrismCredentials.integrationId } : {}),
      limit: "1000"
    }
  });
}

export async function getTxBuildingList(
  token: string,
  building_scope?: string,
  options?: {
    enableTokenManagement?: boolean,
    getAuthToken?: GetAuthTokenResponse,
    channelIntegrationId?: string
  }
): Promise<Res<RawListBuildingData>> {
  return request({
    token,
    method: 'get',
    path: `/buildings`,
    enableTokenManagement: options?.enableTokenManagement,
    getAuthToken: options?.getAuthToken,
    channelIntegrationId: options?.channelIntegrationId,
    ...(building_scope && { params: { building_scope } })
  });
}
